<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import { t, translationExists } from "../../stores/translations";
  import { breakpoints } from "../../data/breakpoints";
  export let question;
  export const properties = {};

  const dispatch = createEventDispatcher();

  let selected: number = 0;
  let dragSelecting: boolean = false;
  let orient: string = "vertical";
  let innerwidth: number;

  $: {
    document.body.style.overflowY = dragSelecting ? "hidden" : "";
    if (!dragSelecting) select(selected);
  }

  $: {
    orient = innerwidth >= breakpoints.desktop ? "horizontal" : "vertical";
  }

  onMount(() => {
    select(0);
  });

  /**
   * Dispatch the select event.
   *
   * @param answer
   */
  function select(index: number) {
    dispatch("select", question.answers[index]);
  }
</script>

<svelte:window bind:innerWidth={innerwidth} />

<div>
  {#if $translationExists(`questions.${question.slug}.subtitle`)}
    <h2 class="subtitle">
      {$t(`questions.${question.slug}.subtitle`)}
    </h2>
  {/if}

  <input
    type="range"
    min="0"
    max={question.answers.length - 1}
    {orient}
    on:mousedown={() => (dragSelecting = true)}
    on:mouseup={() => (dragSelecting = false)}
    bind:value={selected}
  />

  <ul>
    {#each question.answers as answer, index}
      <li
        value={answer.id}
        on:click={() => (selected = index)}
        on:keyup={() => (selected = index)}
        class:selected={selected === index}
      >
        <p>{$t(`questions.${question.slug}.answers.${answer.slug}`)}</p>
      </li>
    {/each}
  </ul>
</div>

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  .disableScroll {
    overflow-y: hidden;
  }

  div {
    margin-left: 1rem;
    padding: 0.5rem 2rem;
    overflow: hidden;

    & > .subtitle {
      display: none;
      font-family: "Roboto";
    }

    & > input[type="range"] {
      transform: translate(-50%, 168px) rotate(270deg);
      width: 336px;
      height: 16px;
      appearance: none;
      background: linear-gradient(90deg, $color-secondary, $color-primary);
      cursor: pointer;
      border-radius: 21px;
    }

    & > input[type="range"]::-webkit-slider-runnable-track {
      margin: 0 6px;
    }

    & > input[type="range"]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      margin-top: -6px;
      background-color: $color-white;
      height: 32px;
      width: 32px;
      border-radius: 50%;
      transform: translateY(3px);
      box-shadow: 0px 1px 20px rgba(34, 35, 40, 0.4);
    }

    & > input[type="range"]::-moz-range-thumb {
      appearance: none;
      background-color: $color-white;
      border-color: transparent;
      height: 32px;
      width: 32px;
      border-radius: 50%;
      box-shadow: 0px 1px 20px rgba(34, 35, 40, 0.4);
    }

    & > ul {
      display: flex;
      height: 336px;
      flex-direction: column-reverse;
      justify-content: space-between;
      align-items: flex-end;
      padding: 0;
      list-style: none;
      width: fit-content;
      transform: translate(44px, -13px);
      margin: 0;

      & > li {
        padding: 0.75rem 1rem;
        background-color: $color-secondary;
        color: $color-text;
        border-radius: 8px;
        width: fit-content;
        cursor: pointer;

        & > p {
          font-family: "Roboto";
          margin: 0;
          font-size: $font-size-medium;
          line-height: 1.25rem;
        }

        &.selected {
          text-shadow: 0px 0px 1px $color-white;
          color: $color-white;
          background-color: $color-primary;
        }
      }
    }

    @supports (-moz-appearance: none) {
      display: flex;
      overflow: visible;

      & > input[type="range"] {
        transform: none;
        width: 16px;
        height: 336px;
        background: linear-gradient(0deg, $color-secondary, $color-primary);
      }

      & > datalist {
        transform: none;
        margin-left: 2rem;
      }
    }
  }

  @include desktop {
    div {
      position: relative;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;

      & > .subtitle {
        display: block;
        font-size: $font-size-large;
        font-weight: $font-weight-normal;
        font-style: italic;
        color: $color-text;
        margin: 0 0 2rem 0;
      }

      ul {
        margin-top: 2rem;
        flex-direction: row;
        height: auto;
        transform: none;
        gap: 16px;
        width: auto;
        text-align: center;

        & > li {
          padding: 0.5rem 0.75rem;
          width: 90px;
        }
      }

      & > input[type="range"] {
        transform: none;
        width: auto;
        margin: 0 16px;
        height: 16px;
        appearance: none;
        background: linear-gradient(90deg, $color-secondary, $color-primary);
        cursor: pointer;
        border-radius: 21px;
      }

      & > input[type="range"]::-webkit-slider-runnable-track {
        margin: 0 24px;
      }
    }
  }
</style>
